import file from "./file";
import messages from "./messages";

export default {
    namespaced: true,
    modules: {file, messages}
}